/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_ProjectInputs */

const en_reference_field_project = /** @type {(inputs: Reference_Field_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

/**
* | output |
* | --- |
* | "Project" |
*
* @param {Reference_Field_ProjectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_project = /** @type {((inputs?: Reference_Field_ProjectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_ProjectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_project(inputs)
});